import { useRelationshipsRelationshipShowQuery } from "@/services/backend/relationships/api/service";

export function useCommitment(relationshipId: string, commitmentId: string) {
  const {
    data: relationship,
    isLoading,
    error,
  } = useRelationshipsRelationshipShowQuery({
    id: relationshipId!,
  });

  if (!relationship) {
    return { data: undefined, isLoading, error };
  }

  const commitment = relationship.commitments.find(
    (c) => c.id === commitmentId,
  );

  if (!commitment) {
    return { data: undefined, isLoading: false, error: { status: 404 } };
  }

  return { data: commitment, isLoading: false, error: undefined };
}
